import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import EsyohWidget887581 from './EsyohWidget887581';

const {FiSearch, FiMessageSquare, FiAward} = FiIcons;

const steps = [
  {
    icon: FiSearch,
    title: 'Research Programs',
    text: 'Compare PTA programs by location, accreditation status, prerequisites, schedule, clinical education, credential, and total cost.',
  },
  {
    icon: FiMessageSquare,
    title: 'Request Details',
    text: 'Ask each school about application deadlines, observation requirements, clinical placements, lab access, background checks, and licensure support.',
  },
  {
    icon: FiAward,
    title: 'Plan Your Career',
    text: 'Choose a pathway that matches your goals, then prepare for graduation, the PTA licensure examination, and supervised patient care.',
  },
];

function Process() {
  return (
    <section className="process-section section">
      <EsyohWidget887581 />
      <div className="section-heading">
        <p className="eyebrow">Your next chapter</p>
        <h2>Start Your PTA Career in Tampa</h2>
        <p>
          Physical therapist assistants support patients working to improve
          movement, function, strength, and independence. Tampa Bay students can
          compare programs throughout the region and nearby Florida communities
          before selecting the education pathway that fits their goals.
        </p>
      </div>
      <div className="steps">
        <div className="step-line" aria-hidden="true" />
        {steps.map((step, index) => (
          <article className="step" key={step.title}>
            <div className="step-icon">
              <SafeIcon icon={step.icon} />
              <span>{index + 1}</span>
            </div>
            <div>
              <small>Step {index + 1}</small>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </div>
          </article>
        ))}
      </div>
      <button
        className="secondary-button"
        onClick={() =>
          document.getElementById('programs')?.scrollIntoView({
            behavior: 'smooth',
          })
        }
      >
        Compare Tampa PTA programs
      </button>
    </section>
  );
}

export default Process;